module.exports = __webpack_public_path__ + "static/img/水务bg@2x.6dd60782.png";